export const ROOM_TYPE_MAPPING = {
  1: 'Single room',
  2: 'Double room',
  3: 'Triple room',
  4: 'Quad room'
}
